// src/components/ProtectedRoute.jsx (veya src/hooks/ProtectedRoute.jsx)

import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext'; // AuthContext'inizden user ve loading almanız gerekiyor

/**
 * Bu bileşen, sadece oturum açmış kullanıcıların (owner/sahip) erişebileceği rotaları korur.
 * Oturum açılmamışsa, kullanıcıyı OwnerLogin sayfasına yönlendirir.
 */
export default function ProtectedRoute({ children }) {
    const { user, loading } = useAuth();
    const location = useLocation();

    // 1. AuthContext yüklenirken (token kontrolü vs.)
    if (loading) {
        return <div>Yükleniyor...</div>; // Ya da bir Spinner bileşeni
    }

    // 2. Kullanıcı oturum açmadıysa (Owner değilse)
    // Ancak demo modunda ise (/owner/w/demo- ile başlıyorsa) giriş kontrolünü atla.
    const isDemo = location.pathname.includes('/owner/w/demo-');
    if (!user && !isDemo) {
        return <Navigate to="/owner/login" state={{ from: location }} replace />;
    }

    // 3. Kullanıcı oturum açtıysa veya demo modundaysa, içeriği (children) göster.
    return children;
}